<template>
  <div>
    <button
      class="btn btn-purple ml-2 text-uppercase"
      @click="onExport"
      :disabled="!canExport"
    >Export to csv
    </button>
  </div>
</template>

<script>
import Download from "../../mixins/download";

export default {
  props: {
    exportUrl: String,
    canExport: Boolean,
  },

  methods: {
    /**
     * @return {undefined}
     */
    onExport() {
      this.download(_.assign({}, {url: this.exportUrl}));
    },
  },

  mixins: [
    Download,
  ],
}
</script>

<style scoped>

</style>
